export default "__VITE_ASSET__jkuz6sO9__"